<template>
  <SoDialog
    :model-value="modelValue"
    card-title="EV tariff eligibility checks device breakdown"
    fullscreen
    data-testid="smart-charging-device-modal"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <div class="d-flex flex-wrap ga-6 pa-6">
      <SoWidget
        class="flex-1-1-0 chart-card"
        title="Chargers"
        :loading="loading"
        data-testid="smart-charging-chargers-card"
      >
        <SoPieChart
          v-if="chargerChart.labels.length"
          class="chart"
          :data-set="chargerChart.dataSet"
          :labels="chargerChart.labels"
          :background-colors="chargerChart.colors"
          :maintain-aspect-ratio="false"
          data-testid="smart-charging-chargers-chart"
        />
        <p v-else class="text-body-2 text-medium-emphasis">No data</p>
      </SoWidget>

      <SoWidget
        class="flex-1-1-0 chart-card"
        title="EVs"
        :loading="loading"
        data-testid="smart-charging-evs-card"
      >
        <SoPieChart
          v-if="evChart.labels.length"
          class="chart"
          :data-set="evChart.dataSet"
          :labels="evChart.labels"
          :background-colors="evChart.colors"
          :maintain-aspect-ratio="false"
          data-testid="smart-charging-evs-chart"
        />
        <p v-else class="text-body-2 text-medium-emphasis">No data</p>
      </SoWidget>
    </div>
  </SoDialog>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import SoDialog from "@/components/SoDialog.vue"
  import SoWidget from "@/components/SoWidget.vue"
  import SoPieChart from "@/components/charts/SoPieChart.vue"
  import { ISmartChargingDeviceCount } from "@/models/operations/smartCharging/smartChargingEligibility/smartChargingEligibility.types"
  import { PIE_COLORS } from "./opsSmartChargingConfig"

  export default defineComponent({
    components: { SoDialog, SoWidget, SoPieChart },
    props: {
      modelValue: {
        type: Boolean,
        default: false,
      },
      chargers: {
        type: Array as PropType<ISmartChargingDeviceCount[]>,
        default: () => [],
      },
      evs: {
        type: Array as PropType<ISmartChargingDeviceCount[]>,
        default: () => [],
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["update:modelValue"],
    computed: {
      chargerChart() {
        return this.toChart(this.chargers)
      },
      evChart() {
        return this.toChart(this.evs)
      },
    },
    methods: {
      toChart(items: ISmartChargingDeviceCount[]) {
        return {
          labels: items.map((item) => item.label),
          dataSet: items.map((item) => item.count),
          colors: items.map(
            (_, index) => PIE_COLORS[index % PIE_COLORS.length],
          ),
        }
      },
    },
  })
</script>

<style scoped>
  .chart-card {
    min-width: 320px;
  }
  .chart {
    width: 100%;
    height: 65vh;
    max-height: 640px;
    margin-inline: auto;
  }
</style>
